import { useLazyQuery } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { ROUTES } from '../../../../../common/constants';
import GoBackButton from '../../../../../components/GoBackButton';
import LoaderComponent from '../../../../../components/LoaderComponent';
import Portal from '../../../../../components/Portal';
import EndUsersTabs from '../components/EndUsersTabs';
import OrderInfo from '../components/OrderInfo';
import { USER_ORDER_DETAILS_ADMIN } from '../graphql/Queries';

const ViewOrderDetails = ({
  match: { params: { id, userNumber } = {} } = {},
  endUserId,
  endUserNumber,
  isDrawerView = false,
}) => {
  const [endUserDetail, setEndUserDetail] = useState({});
  const [isEndUserLoading, setIsEndUserLoading] = useState(true);

  const currentId = isDrawerView ? endUserId : id;
  const currentUserNumber = isDrawerView ? endUserNumber : userNumber;

  const [UserOrderDetailsAdmin] = useLazyQuery(USER_ORDER_DETAILS_ADMIN, {
    onCompleted: (response) => {
      setEndUserDetail(response?.userOrderDetailsAdmin?.data);
      setIsEndUserLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {},
  });

  useEffect(() => {
    if (currentId) {
      setIsEndUserLoading(true);
      UserOrderDetailsAdmin({
        variables: {
          where: {
            id: currentId,
          },
        },
      });
    }
  }, [currentId]);

  const contentComponent = (
    <div className="full-height-without-details">
      {isEndUserLoading ? (
        <LoaderComponent
          size="large"
          setHeight="60"
          spinning={isEndUserLoading}
        />
      ) : (
        <OrderInfo
          endUserDetail={endUserDetail}
          userNumber={currentUserNumber}
        />
      )}
    </div>
  );

  if (isDrawerView) {
    return <>{contentComponent}</>;
  }

  return (
    <>
      <Portal portalId="header-title-content">
        <GoBackButton
          customLink={`${ROUTES?.SYSTEM_USERS}${ROUTES?.END_USERS}`}
        />
        <div className="portal-header">View End User</div>
      </Portal>
      <EndUsersTabs
        endUserId={currentId}
        endUserNumber={currentUserNumber}
        isView
      >
        {contentComponent}
      </EndUsersTabs>
    </>
  );
};

export default ViewOrderDetails;
